<template>
    <div class="label-node-header">
        <squareColorUI v-if="showColorSquare && node.layout.color" :color="node.layout.color" />
        <span class="label-node-header-title">
            {{ captionText }} 
            <span v-show="annotations.length > 0" class="label-node-header-annotations">{{ annotationsString }}.</span>
        </span>
    </div>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import squareColorUI from '@/components/ui/squareColor.vue';
import { reportUtils } from '@/features/report/lib/reportUtils';

import LabelAnnotation from '@/features/report/models/LabelAnnotation';

export default {
    name: 'labelNodeHeader',
    components: {
        squareColorUI
    },
    props: {
        node: {
            type: Object,
            required: true
        },
        annotations: {
            type: [LabelAnnotation, Array],
            default: () => []
        },
        showColorSquare: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            gConsts: gConsts
        }
    },
    computed: {
        annotationsString() {
            return reportUtils.getAnnotationsText(this.annotations || []);
        },

        captionText() {
            return this.node.layout.caption + (this.annotations.length > 0 ? ' -' : '');
        }
    }
}
</script>

<style scoped>
.label-node-header {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    width: 100%;
}

.label-node-header-title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--text-sm);
    color: var(--color-black);
    line-height: var(--leading-heading);
}

.label-node-header-annotations {
    font-size: var(--text-sm);
    font-weight: 400;
    color: var(--color-secondary);
}
</style>

